import {
  deleteCookie,
  getParam,
  handleResponse,
  serialize,
  setCookie,
} from "@/businessLogics/_common/http/util";
import { sendLog } from "@/businessLogics/_common/logging";
import { identifyMixpanel } from "@/businessLogics/_common/logging/mixpanel";
import { identifyAmplitude } from "@/businessLogics/_common/logging/amplitude";

const emailCheckUrl = process.env.ONLINE_API_URL + "/v1/auth/login";
const loginUrl = emailCheckUrl;
const redirectUrl = process.env.ONLINE_API_URL + "/v1/oauth/kakao/login";

function requestLogin(
  options: {
    headers: { "x-sparta-iam-access-key": string; "Content-Type": string };
    method: string;
  },
  email: string,
  password: string
) {
  fetch(`${loginUrl}`, {
    ...options,
    body: JSON.stringify({ email, password }),
  })
    .then(handleResponse)
    .then((data) => {
      if (data.user.token) {
        sendLog("sw_login_completed", { method: "email" });
        identifyAmplitude(data.user._id);
        localStorage.setItem("user", JSON.stringify(data.user));
        setCookie("userinfo", serialize(data.user), 3);
        goNext();
      }
      return data.user;
    })
    .catch((err) => {
      alert(err);
      return Promise.reject(err);
    });
}

export async function login(email: string, password: string) {
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-sparta-iam-access-key": "DhhJRJMEIIGnAxeQnVBB", // TODO: 안드러나게 수정
    },
  };

  requestLogin(options, email, password);
}

export function getNext() {
  let next = getParam("next", location.href);
  if (!next) next = "/";
  return next;
}

export function goNext() {
  const decodedURI = decodeURIComponent(getNext());
  window.location.href = decodedURI;
}

export function loginWithKakao(next: string) {
  sendLog("sw_login_completed", { method: "kakao" });
  let state = {
    next: encodeURIComponent(
      `${window.location.origin}${decodeURIComponent(next)}`
    ),
  };
  const redirectUri = redirectUrl;
  let settings = state
    ? { redirectUri, state: JSON.stringify(state) }
    : { redirectUri };

  if (typeof window !== "undefined") {
    let Kakao = window.Kakao;
    Kakao.Auth.authorize(settings);
  }
}

export async function checkEmailExist(email: string) {
  let response: any = await fetch(`${emailCheckUrl}?email=${email}`);
  response = await handleResponse(response);
  return !!response.is_exist;
}

export function getSignUpUrl(_next: string, email: string) {
  return `${process.env.ONLINE_BASE_URL}/signup?next=${encodeURIComponent(
    window.location.origin + decodeURIComponent(_next)
  )}&email=${email}`;
}

export function logOut() {
  deleteCookie("userinfo");
  deleteCookie("user_info");
  deleteCookie("token");
  deleteCookie("user_created_at");
  deleteCookie("user_id");
  localStorage.removeItem("user");
  const next = encodeURIComponent(window.location.href);
  window.location.href = `${process.env.ONLINE_BASE_URL}/logout?next=${next}`;
}
